<!--
    描述： 造价文件模块 ---excel 预览
    时间： xx
    created by zjj
-->
<template>
	<div class="preview-layout">
		excel 预览
	</div>
</template>

<script>
export default {
	name: 'excel-preview',
	props: {
	},
	data() {
		return {}
	}
}
</script>

<style lang="less" scoped>
</style>